import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import CollectionToolTile from './CollectionToolTile';

const FeaturedCollectionsRow = props => {
  const {
    collections = [],
    fptiClick,
    fptiImpression,
    featuredCollectionsTitle
  } = props;

  return (
    collections.length > 0 && (
      <div className="appcenter-category new">
        <div className="category-header new ">
          <HeadingText level={2} >{featuredCollectionsTitle}</HeadingText>
        </div>
        <div className="category-grid singleton featured-grid">
          {collections.map((collection, i) => (
            <CollectionToolTile
              key={i}
              collection={collection}
              fptiClick={fptiClick}
              fptiImpression={fptiImpression}
            />
          ))}
        </div>
      </div>
    )
  );
};

FeaturedCollectionsRow.propTypes = {
  collections: PropTypes.array,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  featuredCollectionsTitle: PropTypes.string
};

export default FeaturedCollectionsRow;
